module.exports = __webpack_public_path__ + "static/media/no-candidate-1800.c09f9eb3.webp";